package components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import calculator.ScenarioResult
import format.formatNumber
import format.formatRub
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr

@Composable
fun ResultsSection(scenarios: List<ScenarioResult>) {
    var detailsVisible by remember { mutableStateOf(false) }

    Div({ classes("scenario-cards") }) {
        scenarios.forEach { scenario ->
            Div({ classes("scenario-card") }) {
                Span({ classes("summary-label") }) { Text(scenario.title) }
                Span({ classes("scenario-card-total") }) { Text(formatRub(scenario.totalRub)) }
            }
        }
    }
    Button({
        classes("secondary-button", "details-toggle")
        attr("aria-expanded", detailsVisible.toString())
        onClick { detailsVisible = !detailsVisible }
    }) {
        Text(if (detailsVisible) "Скрыть подробный расчет" else "Показать подробный расчет")
    }
    Div({
        classes("table-details")
        if (detailsVisible) classes("table-details-expanded")
    }) {
        Div({ classes("mobile-detail-cards") }) {
            scenarios.forEach { scenario ->
                Div({ classes("mobile-detail-card") }) {
                    Div({ classes("mobile-detail-card-header") }) {
                        Span({ classes("summary-label") }) { Text(scenario.title) }
                        Span({ classes("scenario-card-total") }) { Text(formatRub(scenario.totalRub)) }
                    }
                    Div({ classes("mobile-detail-grid") }) {
                        mobileDetailRows(scenario).forEach { row ->
                            Div({ classes("mobile-detail-row") }) {
                                Span({ classes("mobile-detail-label") }) { Text(row.label) }
                                Span({ classes("mobile-detail-value") }) { Text(row.value) }
                            }
                        }
                    }
                }
            }
        }
        Div({ classes("table-scroll") }) {
            ResultsTable(scenarios)
        }
    }
}

internal data class MobileDetailRow(
    val label: String,
    val value: String,
)

internal fun mobileDetailRows(scenario: ScenarioResult): List<MobileDetailRow> {
    return listOf(
        MobileDetailRow("Период", "${formatNumber(scenario.periodDays)} дней"),
        MobileDetailRow("Визаранов/год", formatNumber(scenario.runsPerYear)),
        MobileDetailRow("За период", formatNumber(scenario.runsForPeriod)),
        MobileDetailRow("Поездки", formatRub(scenario.travelCostRub)),
        MobileDetailRow("Потеря дохода", formatRub(scenario.incomeLossRub)),
        MobileDetailRow("Риски и дискомфорт", formatRub(scenario.extraRiskDaysCostRub + scenario.expectedRiskCostRub + scenario.discomfortCostRub)),
        MobileDetailRow("Карта", if (scenario.cardCostRub > 0) formatRub(scenario.cardCostRub) else "-"),
        MobileDetailRow("Экономии", formatRub(scenario.fastTrackSavingsRub + scenario.otherTravelSavingsRub)),
        MobileDetailRow("Итого", formatRub(scenario.totalRub)),
    )
}

@Composable
private fun ResultsTable(scenarios: List<ScenarioResult>) {
    Table({ classes("results-table") }) {
        Thead {
            Tr {
                Th { Text("Вариант") }
                Th { Text("Период") }
                Th { Text("Визаранов/год") }
                Th { Text("За период") }
                Th { Text("Поездки") }
                Th { Text("Рабочие дни") }
                Th { Text("Потеря дохода") }
                Th { Text("Админ") }
                Th { Text("Риск-дни") }
                Th { Text("Риск") }
                Th { Text("Дискомфорт") }
                Th { Text("Карта") }
                Th { Text("Экономии") }
                Th { Text("Итого") }
            }
        }
        Tbody {
            scenarios.forEach { scenario ->
                Tr {
                    Td { Text(scenario.title) }
                    Td { Text("${formatNumber(scenario.periodDays)} дней") }
                    Td { Text(formatNumber(scenario.runsPerYear)) }
                    Td { Text(formatNumber(scenario.runsForPeriod)) }
                    Td { Text(formatRub(scenario.travelCostRub)) }
                    Td { Text(formatNumber(scenario.lostWorkDays)) }
                    Td { Text(formatRub(scenario.incomeLossRub)) }
                    Td { Text(formatRub(scenario.adminTimeCostRub)) }
                    Td { Text(formatRub(scenario.extraRiskDaysCostRub)) }
                    Td { Text(formatRub(scenario.expectedRiskCostRub)) }
                    Td { Text(formatRub(scenario.discomfortCostRub)) }
                    Td { Text(if (scenario.cardCostRub > 0) formatRub(scenario.cardCostRub) else "-") }
                    Td { Text(formatRub(scenario.fastTrackSavingsRub + scenario.otherTravelSavingsRub)) }
                    Td({ classes("total-cell") }) { Text(formatRub(scenario.totalRub)) }
                }
            }
        }
    }
}
